import { api } from './index';

// The registros clínicos the office anula (ClinicalRecordVoidPolicy::CHECKS).
export type ClinicalVoidItemType =
  | 'ReportText'
  | 'ReportImage'
  | 'VitalSignRecord'
  | 'MedicalRecord'
  | 'TaskRecord'
  | 'IncidentRecord'
  | 'Note'
  | 'PatientDocument';

// The registro that replaces the anulado one: the right text of a report text
// or a note, the right value of a vital sign (systolic and diastolic for a
// blood pressure).
export type ClinicalCorrection = {
  text?: string;
  value?: string;
  systolic?: string;
  diastolic?: string;
};

export type ClinicalVoidRequest = {
  itemType: ClinicalVoidItemType;
  itemId: number;
  reason: string;
  correction?: ClinicalCorrection | null;
};

export const clinicalRecordVoidsApi = {
  create(request: ClinicalVoidRequest): Promise<void> {
    return api({
      method: 'post',
      url: '/api/internal/clinical_record_void',
      data: request,
    }).then(() => {});
  },
};
